var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28h28V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 21.047v1.75H5.25v-1.75h17.5zm-13.125-8.75v7h-1.75v-7h1.75zm10.5 0v7h-1.75v-7h1.75zm-5.875.953c.736 0 1.333.61 1.333 1.364 0 .708-.528 1.291-1.205 1.357l-.11.005.426.001c.886 0 1.493.6 1.551 1.454l.005.137v.682h-.889v-.682c0-.395-.198-.639-.563-.676l-.104-.006h-.888c-.396 0-.627.21-.662.578l-.005.104v.682h-.889v-.682c0-.88.563-1.524 1.418-1.586l.138-.005h.425c-.728-.01-1.314-.617-1.314-1.363 0-.753.597-1.364 1.333-1.364zm0 .91a.45.45 0 0 0-.444.454.45.45 0 0 0 .444.454.45.45 0 0 0 .444-.454.45.45 0 0 0-.444-.455zM14 5.25l8.75 2.917v2.38H5.25v-2.38L14 5.25zm0 1.845L8.892 8.797h10.216L14 7.095z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/merchant.bfad44319226134acfdc18dbcd805dc8.svg";
export { ForwardRef as ReactComponent };